import { useSearchParams } from "react-router-dom";
import { cleanParams } from "../utils/cleanParams"; // 경로는 프로젝트에 맞게 수정

interface UseSearchFiltersReturn {
  page: string;
  size: string;
  searchType: string;
  searchWord: string;
  solutionFilter: string;
  noticeTypeFilter: string;
  updateFilters: (filters: Record<string, string>) => void;
  getFilter: (key: string, defaultValue?: string) => string;
}

export const useSearchFilters = ({
  initType = "title",
}: {
  initType?: string;
}): UseSearchFiltersReturn => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getFilter = (key: string, defaultValue = "all") => {
    return searchParams.get(key) || defaultValue;
  };

  const updateFilters = (filters: Record<string, string>) => {
    setSearchParams((prev) => {
      const prevObj = Object.fromEntries(prev.entries());
      return cleanParams({
        ...prevObj,
        ...filters,
      });
    });
  };

  return {
    page: getFilter("page", "1"),
    size: getFilter("size", "10"),
    searchType: getFilter("searchType", initType),
    searchWord: getFilter("keyword", ""),
    solutionFilter: getFilter("solution"),
    noticeTypeFilter: getFilter("noticeType"),
    updateFilters,
    getFilter,
  };
};
